// CurrencyDropdown.jsx
import React from 'react'
import { Box, Select, MenuItem, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import styles from './index.module.css'
const FLAG_BASE = 'https://flagcdn.com'; // w20/w40 available

// Infer a 2-letter flag code from currency id (fallback to provided opt.country/opt.flag)
const inferFlagCode = (opt = {}) => {
  // First honor explicit fields if present
  const explicit = (opt.flag || opt.country || '').toString().trim().toLowerCase();
  if (explicit) return explicit;

  // Fallback inference from currency code
  switch ((opt.id || '').toUpperCase()) {
    case 'USD': return 'us';
    case 'EUR': return 'eu'; // FlagCDN supports "eu"
    case 'GBP': return 'gb';
    case 'CAD': return 'ca';
    case 'INR': return 'in';
    case 'AUD': return 'au';
    case 'NZD': return 'nz';
    case 'JPY': return 'jp';
    case 'CNY': return 'cn';
    default: return ''; // no flag
  }
};
const FlagIcon = ({ code, size = 20, alt = '' }) => {
  if (!code) return null;
  // size: use w20 for compact menus/inputs
  return (
    <img
      src={`${FLAG_BASE}/w${size}/${code}.png`}
      alt={alt}
      width={size}
      height={Math.round(size * 0.75)}
      style={{ display: 'inline-block', marginRight: 8, borderRadius: 2 }}
      loading="lazy"
    />
  );
};

const CurrencyDropdown = ({
  handleSelect,
  selectedValue,
  options,
  name,
  disabled = false
}) => {
  const menuProps = {
    PaperProps: { className: styles.menuPaper },
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    transformOrigin: { vertical: 'top',    horizontal: 'right' }
  };

  const renderLabel = (opt) => opt?.label ?? opt?.name ?? '';

  return (
    <>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontSize: '0.9rem', color: '#555' }}
      >
        Currency
      </Typography>

      <Select
        className={styles.dropdown}
        value={selectedValue}
        onChange={(e) => handleSelect(e, name)}
        displayEmpty
        MenuProps={menuProps}
        IconComponent={KeyboardArrowDownIcon}
        disabled={disabled}
        renderValue={(val) => {
          const o = options.find(o => o.id === val);
          if (!o) return 'Select currency';
          const code = inferFlagCode(o);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FlagIcon code={code} alt={renderLabel(o)} />
              {renderLabel(o)}
            </Box>
          );
        }}
        sx={{
          minWidth: 200,
          '& .Mui-disabled': {
            cursor: 'not-allowed'
          }
        }}
      >
        {options.map((opt) => {
          const label = renderLabel(opt);
          const code = inferFlagCode(opt);
          return (
            <MenuItem key={opt.id} value={opt.id} className={styles.option}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FlagIcon code={code} alt={label} />
                {label}
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default CurrencyDropdown